export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";